jQuery(".list--v1 .list__title").on("click", function() {
  const content = jQuery(this)
    .parent()
    .find(".list__content");

  const className = ".list__content--open";

  if (content.hasClass(className)) {
    content
      .removeClass(className)
      .slideUp()
      .find("span")
      .css("transform", "rotate(180deg)");
  } else {
    content
      .addClass(className)
      .slideDown()
      .find("span")
      .css("transform", "initial");
  }
});
